const commonButtonStyle = {
  borderRadius: 0,
  textTransform: "none",
  fontWeight: 400,
  _focus: { boxShadow: "none", outlineColor: "none" },
  _focusVisible: { boxShadow: "0 0 0 3px #2A7FFE", outlineColor: "#2A7FFE" },
};

const Button = {
  variants: {
    unstyled: {
      ...commonButtonStyle,
    },
    primary: {
      ...commonButtonStyle,
      bg: "bluefrance",
      color: "white",
      _hover: { bg: "#0000dd" },
      _disabled: { color: "#666", bg: "#2A2A2A" },
    },
    secondary: {
      ...commonButtonStyle,
      bg: "white",
      color: "bluefrance",
      border: "1px solid",
      borderColor: "bluefrance",
      _hover: { bg: "#efefef" },
      _disabled: { color: "#666", borderColor: "#2A2A2A" },
    },

    pill: {
      ...commonButtonStyle,
      borderRadius: 24,
      height: "auto",
      fontSize: "zeta",
      color: "bluefrance",
      px: 3,
      py: 1,
      _hover: { bg: "grey.200", textDecoration: "none" },
    },
    outlined: {
      ...commonButtonStyle,
      color: "black",
    },
    slight: {
      ...commonButtonStyle,
      fontWeight: 400,
      color: "#666666",
      fontSize: "0.8rem",
      fontStyle: "italic",
      textDecoration: "underline",
    },
    danger: {
      ...commonButtonStyle,
      color: "redmarianne",
    },
  },
};

export { Button };
